
// EgresadosRoutes.jsx 
import { Routes, Route, useLocation } from 'react-router-dom';
import { Navigate, } from 'react-router-dom';
import { PrivateEgresadosLayout } from './../layout/PrivateEgresadosLayout';

import LoginEgresados from './../pages/Alumnos/Login/Login';
import EgresadosHome from './../pages/Alumnos/Home';
import PassResetForm from './../pages/Alumnos/Login/PassResetForm';
import AccountValidation from './../pages/Alumnos/Login/AccountValidation';
import AuthLayout from './../pages/Alumnos/Login/layouts/AuthLayout';

const EgresadosRoutes = () => {

  const location = useLocation();

  if (!location.pathname.startsWith("/egresados") ) { 
    return <Navigate to="/egresados/inicio-sesion" replace />;
  }

  return (
    <Routes>
      {/* Rutas privadas para alumnos*/}
      <Route path="*" element={<PrivateEgresadosLayout/>}>
        <Route index element={<EgresadosHome />} />
        <Route path="*" element={<Navigate to="/egresados"  replace />} />
      </Route>


      {/* Rutas públicas */}
      <Route path="*" element={<AuthLayout />}>   
        <Route path="inicio-sesion" element={<LoginEgresados />} />
        <Route path="reset-password/:token" element={<PassResetForm />} />
        <Route path="activar-cuenta/:token" element={<AccountValidation />} />
      </Route>

    </Routes>
  );
};
export default EgresadosRoutes 